// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export function mpcreditoOutgoingPaymentMapper(): $Shape<OutgoingPayment> {
  return {
    payment_type: 'externalpayprovider',
    payment_type_code: 'mpcredito',
  };
}
